export default __webpack_public_path__ + "static/media/alc_video.43ae5b3e.webm";